module.exports = __webpack_public_path__ + "img/head.be809c61.png";